import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-menu-link',
  templateUrl: './menu-link.component.html',
  styleUrls: ['./menu-link.component.scss']
})
export class MenuLinkComponent implements OnInit {
	
	
	@Input() id:string;
	@Input() label:string;
	@Input() active:boolean = true;
	@Input() open:boolean = false;
	
	img:string;
	idimg:string;
	text:string;

  constructor() { }

  ngOnInit() {
		
		
		//todo event variable change
		
		
	}
	
	
	ngOnChanges(changes:SimpleChanges):void
	{
		if(changes.open){
			
			if(this.open) this.idimg = 'close';
			else this.idimg = this.id;
			
			this.text = (this.open) ? "fermer" : this.label;
			
		}
		
		
	}

}
